/**
 * El ícono de carpeta de la app, en SVG web. Fuente:
 * `apps/mobile/src/shared/ui/icons/folder-icon.tsx`, path por path.
 *
 * ## Por qué se porta en vez de usar el `Folder` de `lucide-react`
 *
 * El de lucide es un CONTORNO y éste es una silueta MACIZA. A 28 px sobre el gris de la portada, la
 * diferencia no es un detalle de estilo: la fila de carpeta se lee por su mancha naranja, y un
 * alambre del mismo tamaño se pierde. Es el único ícono del módulo Documentos que la app dibuja por
 * su cuenta, y por eso el único que hay que traer.
 *
 * ## El alto NO es el ancho
 *
 * El original mide 28 × 29: `size` es el ANCHO y el alto sale del ratio, igual que en la app.
 * Igualar los dos aplastaría la solapa un píxel — poco, pero visible al lado de la versión real.
 */

/** 29 / 28: la carpeta es apenas más alta que ancha. */
const RATIO = 29 / 28

export type FolderIconProps = {
  size?: number
  /** Cualquier color CSS. Por defecto el naranja de la marca, como en la app. */
  color?: string
}

export function FolderIcon({ size = 28, color = 'var(--cap-accent-500)' }: FolderIconProps) {
  return (
    <svg
      width={size}
      height={size * RATIO}
      viewBox="0 0 28 29"
      fill="none"
      role="presentation"
      aria-hidden
    >
      <path
        d="M22.7723 23.8094C23.3763 23.8094 23.9556 23.5585 24.3827 23.112C24.8098 22.6655 25.0497 22.0599 25.0497 21.4284V9.52367C25.0497 8.8922 24.8098 8.2866 24.3827 7.84008C23.9556 7.39357 23.3763 7.14272 22.7723 7.14272H13.7764C13.3955 7.14662 13.0198 7.05059 12.6836 6.86341C12.3474 6.67623 12.0615 6.40388 11.852 6.07129L10.9296 4.64272C10.7223 4.31352 10.44 4.04329 10.108 3.85628C9.77614 3.66928 9.40502 3.57135 9.02798 3.57129H4.55282C3.94881 3.57129 3.36954 3.82214 2.94244 4.26865C2.51533 4.71517 2.27539 5.32077 2.27539 5.95224V21.4284C2.27539 22.0599 2.51533 22.6655 2.94244 23.112C3.36954 23.5585 3.94881 23.8094 4.55282 23.8094H22.7723Z"
        fill={color}
      />
    </svg>
  )
}
